// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__35PPr","sendOtp":"AuthorizeToLogin_sendOtp__2IPBE"};